module.exports = __webpack_public_path__ + "img/tab-orders-active.f6407b65.svg";